import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { compose } from 'redux';
import { withTranslation } from 'react-i18next';
import { Row } from 'reactstrap';
import { MainHeader } from '../../components/Header';
import { DataTable, TablePagination, AccountHeaderForm } from '../../components/common';
import CreditNotesSearchForm from '../../components/CreditNotes/CreditNotesSearchForm';
import { getAccountId } from '../../localStorage';
import { makeGetPermissionSelfCare, makeGetCcpProperty } from '../App/selectors';
import { searchNotesUnits, getActivityById, getObjectFileById } from '../App/actions';
import RouteNames from '../App/RouteNames';
import { getPageTotalCount } from '../../utils/utils';

import './styles.scss';

const orderSort = {
  startDate: {
    asc: 'startDate_ASC',
    desc: 'startDate_DESC',
  },
  notesDate: {
    asc: 'endDate_ASC',
    desc: 'endDate_DESC',
  },
  type: {
    asc: 'arNotestype_ASC',
    desc: 'arNotestype_DESC',
  },
  accountId: {
    asc: 'accountId_ASC',
    desc: 'accountId_DESC',
  },
};

export class ViewPayment extends React.Component {
  state = {
    page: 0,
    size: 20,
    filter: {},
    sorted: {},
    totalCount: null,
    isSearching: false,
    isActiveNext: false,
    totalCount: null,
  };

  componentDidMount = () => {
    this.doSearchNotesUnits();
  };

  doSearchNotesUnits = () => {
    const { page, size, sorted, filter, totalCount } = this.state;
    const { searchNotesUnits } = this.props;
    const sort =
      sorted && sorted.sortCol && sorted.sortDir && orderSort[sorted.sortCol]
        ? orderSort[sorted.sortCol][sorted.sortDir]
        : null;
    this.setState({ isSearching: true });
    const params = {
      page: page + 1,
      size,
      sorted,
      filter: { ...filter, accountId: getAccountId(), fetchFinalizedNotes: 'true' },
    };
    if (sort) {
      params.sort = sort;
    }
    searchNotesUnits(params, ({ success, data }) => {
      this.setState({
        isSearching: false,
        page,
        size,
        filter,
        sort,
        data: success ? data : [],
        isActiveNext: !!(data && data.length === size),
        totalCount: getPageTotalCount({ totalCount: totalCount || data?.length, size, items: data || [], page }),
      });
    });
  };

  onSubmitSearch = filteredData => {
    this.setState({ filter: { ...filteredData }, page: 0 }, () => this.doSearchNotesUnits());
  };

  onPageChange = pageChange => {
    const { page } = this.state;
    if (page === pageChange) return '';
    return this.setState({ page: pageChange }, () => this.doSearchNotesUnits());
  };

  onSizeChange = size => {
    this.setState({ size, page: 0 }, () => this.doSearchNotesUnits());
  };

  onSortColumn = (sortCol, sortDir) => {
    this.setState({ sorted: { sortCol, sortDir } }, () => this.doSearchNotesUnits());
  };

  doGetObjectFileById = invoiceId => {
    const { getObjectFileById, history } = this.props;
    getObjectFileById(invoiceId, data => {
      if (data && data.length) {
        history.push({
          pathname: RouteNames.prettifyPath(RouteNames.creditNotesInfo.path, invoiceId),
          state: {
            fromPath: RouteNames.prettifyPath('/view-credit-notes'),
            fileData: data,
          },
        });
      }
    });
  };

  render() {
    const { permissionsSelfCare, t, ccpProperty } = this.props;
    const { data, page, isActiveNext, size, sorted, totalCount } = this.state;
    const tableColumns = [
      {
        name: 'accountId',
        label: 'label.accountId',
        render: () => {
          return <span>{getAccountId()}</span>;
        },
      },
      {
        name: 'id',
        label: 'label.id',
        render: (colName, item) => (
          // <Link
          //   className="no-border btn-link"
          //   to={{
          //     pathname: RouteNames.prettifyPath(RouteNames.creditNotesInfo.path, item.id),
          //     state: {
          //       fromPath: RouteNames.prettifyPath('/view-credit-notes'),
          //     },
          //   }}
          // >
          //   {item.id}
          // </Link>
          <button
            type="button"
            className="btn btn-outline-success btn-sm btn-view-file"
            onClick={() => this.doGetObjectFileById(item.id)}
          >
            {item.id}
          </button>
        ),
      },
      {
        name: 'notesDate',
        label: 'common:label.date',
        sortable: true,
      },
      {
        name: 'type',
        label: 'common:label.noteType',
        isRenderT: true,
        sortable: true,
        render: (colName, item, t) => {
          const slt = t ? t('selections:arNotesType')().find(val => val.value === item.type) : '';
          return <span>{slt ? slt.label : ''}</span>;
        },
      },
      {
        name: 'total',
        label: 'common:label.total',
      },
      {
        name: 'status',
        label: 'common:label.status',
        isRenderT: true,
        render: (colName, item, t) => {
          const slt = t ? t('selections:noteStatus')().find(val => val.value === item.status) : '';
          return <span>{slt ? slt.label : ''}</span>;
        },
      },
      {
        name: 'select',
        label: 'label.view',
        isRenderT: true,
        render: (colName, item, t) => (
          // <Link
          //   className="btn btn-outline-success btn-sm"
          //   to={{
          //     pathname: RouteNames.prettifyPath(RouteNames.creditNotesInfo.path, item.id),
          //     state: {
          //       fromPath: RouteNames.prettifyPath('/view-credit-notes'),
          //     },
          //   }}
          // >
          //   {t('label.view')}
          // </Link>

          <button
            type="button"
            className="btn btn-outline-success btn-sm"
            onClick={() => this.doGetObjectFileById(item.id)}
          >
            {t('label.view')}
          </button>
        ),
      },
    ];

    let historicalFolioLink = null;
    if (ccpProperty && ccpProperty.ccpPropertyList && ccpProperty.ccpPropertyList.length) {
      const historicalFolioLinkProperty = ccpProperty.ccpPropertyList.find(
        val => val.property === 'historicalFolioLink'
      );
      if (historicalFolioLinkProperty) historicalFolioLink = historicalFolioLinkProperty.value;
    }

    return (
      <div className="manage-page global-page">
        <MainHeader activeTab="Billing Data" />
        <div className="manage-page__form p-3">
          <div className="form-billing">
            <div className="col-md-12 row pt-4 group-input-billing" onSubmit={this.onSubmit}>
              <div className="col-md-12 p-0">
                <Row>
                  {/* <div className="col-md-12 pl-0 pr-0 pt-0 pb-3">
                    <h4 className="card-title-mb">
                      {t('label.creditNotes')}
                      <span className="account-number">
                        <span className="account-detail">{`${t('label.accountNumber')}:`}</span>
                        &nbsp;&nbsp;
                        <span className="account-detail">{getAccountId()}</span>
                      </span>
                    </h4>
                  </div> */}
                  <AccountHeaderForm title={t('label.creditNotes')} historicalFolioLink={historicalFolioLink} />
                </Row>
                <br />
              </div>
              <CreditNotesSearchForm onSubmit={this.onSubmitSearch} />
            </div>
            <div className="group-input-billing">
              <DataTable
                columns={tableColumns}
                isFixedHeaderTable
                data={data || []}
                onSort={this.onSortColumn}
                sorted={sorted}
              />
              <div className="col-md-12 pl-0 pr-0 pt-3">
                <div className="mb-30">
                  <TablePagination
                    pageNumber={page}
                    pageSize={size}
                    totalCount={totalCount}
                    onPageChange={this.onPageChange}
                    onSizeChange={this.onSizeChange}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

ViewPayment.propTypes = {
  searchNotesUnits: PropTypes.func.isRequired,
  getActivityById: PropTypes.func.isRequired,
};

const mapStateToProps = createStructuredSelector({
  permissionsSelfCare: makeGetPermissionSelfCare() || {},
  ccpProperty: makeGetCcpProperty() || {},
});

function mapDispatchToProps(dispatch) {
  return {
    searchNotesUnits: (data, cb) => dispatch(searchNotesUnits(data, cb)),
    getActivityById: (data, cb) => dispatch(getActivityById(data, cb)),
    getObjectFileById: (data, cb) => dispatch(getObjectFileById(data, cb)),
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default withTranslation(['common'])(compose(withConnect)(ViewPayment));
